import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MedicationDetailsComponent } from './medication-details.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule],
  declarations: [MedicationDetailsComponent],
  exports: [MedicationDetailsComponent]
})
export class MedicationDetailsModule { }
